import { createLazyFileRoute } from "@tanstack/react-router";
import { memo } from "react";

import { AccessionPage } from "@/features/accession/routes/Accessions";

export const Route = createLazyFileRoute("/_auth/_app/accessions/")({
  component: memo(() => {
    return <AccessionPage />;
  }),
});
